import { render } from "./statistics.vue?vue&type=template&id=48999886&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"

import "./statistics.vue?vue&type=style&index=0&id=48999886&lang=scss&scoped=true"
import "./statistics.vue?vue&type=style&index=1&id=48999886&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48999886"]])

export default __exports__